module.exports = __webpack_public_path__ + "files/25ed0e8082504bffa32e223eb38eca46.png";